import React, { Component } from 'react'
import BootstrapTable from "react-bootstrap-table-next"
import ToolkitProvider from 'react-bootstrap-table2-toolkit'
import { Col, Row, Label } from 'reactstrap'
import { inject, observer } from 'mobx-react';
import { IconeInformacao } from '../../comum/components/Icones'
import { CollapseItemTableIndicator } from '../../comum/components/CollapseItemTableIndicator'

@inject("store")
@observer
export default class TabelasAcomp extends Component {
    
    constructor(props){
        super(props)

        this.controller = this.props.controller
    }

    render() {
        
        let lista =  this.props.dados;
        //Se a lista tiver somente um resultado, mostrar a row de detalhes já expandida.
        let toExpand=null;
        if(lista.length === 1){
            toExpand = lista[0].ContainerId;
        }

        const detalhesRow = {
            renderer: row => (                
                <Row>
                     <Col xl={12} lg={12} sm={'auto'} xs={6} className="container-card-detalhe-anexos">
                        <div>
                            <Row className="ml-1 d-flex justify-content-center align-items-center">
                                {row.MsgAvaria ? 
                                    <span style={{color: 'black'}}><strong>{row.MsgAvaria.toUpperCase()}</strong></span>
                                    :
                                    <span><strong>"-"</strong></span>
                                }
                            </Row>
                        </div>
                    </Col>
                </Row>
            ),
            expanded: [toExpand],
            showExpandColumn: true,
            expandByColumnOnly: true,
            expandHeaderColumnRenderer: () => "Detalhes",
            expandColumnPosition: 'right',
            expandByColumnOnly: true,
            onExpandAll: (isExpandAll, results, e) => {
                e.PreventDefault();
            },
            expandColumnRenderer: ({ expanded }) => {
                if (expanded) {
                    return (
                        <CollapseItemTableIndicator expanded={expanded}/>
                    );
                }
                return (
                    <CollapseItemTableIndicator expanded={expanded}/>
                );
            },
            
        };

        return (
            <React.Fragment>
                <ToolkitProvider
                    keyField={this.props.keyField}
                    data={this.props.dados}
                    columns={this.props.colunas}
                >
                    {props => 
                    <div className="tabela-overflow">
                        <BootstrapTable bootstrap4
                                    striped
                                    bordered={false}
                                    classes="tabela tabela-layout"
                                    expandRow={this.props.avaria && process.env.rig && this.controller.tipoAcompanhamento === "I" ? detalhesRow : false}
                            {...props.baseProps}
                        />
                        {this.props.mensagemNotaFiscal && 
                        <React.Fragment>
                            <div className="mb-2" style={{display: 'block', width: '100%', height:'2px', backgroundColor:'#F0F2F5'}} />
                            <Col xs={12} sm={12} md={12} lg={12} xl={12} className="pl-4 ml-3 mb-2 d-flex justify-content-start align-items-center">
                                <Row className="pb-0">
                                    <div className="flex-row d-flex align-items-center">
                                        <IconeInformacao style={{width: '20px'}} className={'mr-2'} />
                                        <Label className="mb-0 aviso-form">A etapa do faturamento refere-se apenas à emissão da nota fiscal eletrônica</Label>
                                    </div>
                                </Row>
                            </Col>
                        </React.Fragment>
                        }
                    </div>
                    }
                </ToolkitProvider>
            </React.Fragment>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/acompanhamento/components/TabelasAcomp.js